import { SystemRole } from './roles';

// Define path names here
export enum RoutePaths {
    Home = 'home',
    Login = 'login',
    Offline = 'offline',
    ManageUsers = 'users',
    ManageSIP = 'managesip',
    NewVisit = 'newvisit',
    MyVisits = 'myvisits',
    ViewVisit = 'viewvisit',
    SIPEditor = 'sipeditor',
    UsersEditor = 'userseditor',
    VisitSearch = 'visitsearch',
    ContentAreaEditor = 'contentareaeditor',
    Reports = 'reports',
    ViewGoals = 'viewgoals',
    Classlink = 'classlink',
}

// Define the roles which have access to each route listed above.
export const RouteRoles = {
    All: [SystemRole.All],
    Home: [SystemRole.All],
    Login: [SystemRole.All],
    Classlink: [SystemRole.All],
    Offline: [SystemRole.All],
    ManageSIP: [SystemRole.Developer, SystemRole.SystemAdmin, SystemRole.SIPAdmin],
    ManageUsers: [SystemRole.Developer, SystemRole.SystemAdmin],
    NewVisit: [
        SystemRole.Developer,
        SystemRole.SystemAdmin,
        SystemRole.SIPAdmin,
        SystemRole.StandardUser,
        SystemRole.ContentAreaAdmin,
    ],
    MyVisits: [
        SystemRole.Developer,
        SystemRole.SystemAdmin,
        SystemRole.SIPAdmin,
        SystemRole.StandardUser,
        SystemRole.ContentAreaAdmin,
        SystemRole.Principal,
        SystemRole.AssistantPrincipal,
        SystemRole.Regional,
    ],
    ViewVisit: [
        SystemRole.Developer,
        SystemRole.SystemAdmin,
        SystemRole.SIPAdmin,
        SystemRole.StandardUser,
        SystemRole.ContentAreaAdmin,
        SystemRole.Principal,
        SystemRole.AssistantPrincipal,
        SystemRole.Regional,
    ],
    SIPEditor: [SystemRole.Developer, SystemRole.SystemAdmin, SystemRole.SIPAdmin],
    UsersEditor: [SystemRole.Developer, SystemRole.SystemAdmin],
    VisitSearch: [
        SystemRole.Developer,
        SystemRole.SystemAdmin,
        SystemRole.ContentAreaAdmin,
        SystemRole.Principal,
        SystemRole.AssistantPrincipal,
        SystemRole.Regional,
    ],
    ContentAreaEditor: [SystemRole.Developer, SystemRole.SystemAdmin],
    Reports: [
        SystemRole.Developer,
        SystemRole.SystemAdmin,
        SystemRole.SIPAdmin,
        SystemRole.ContentAreaAdmin,
        SystemRole.Principal,
        SystemRole.AssistantPrincipal,
        SystemRole.Regional,
        SystemRole.StandardUser,
    ],
    ViewGoals: [
        SystemRole.Developer,
        SystemRole.SystemAdmin,
        SystemRole.SIPAdmin,
        SystemRole.StandardUser,
        SystemRole.ContentAreaAdmin,
        SystemRole.Principal,
        SystemRole.AssistantPrincipal,
        SystemRole.Regional,
    ],
};
